import React from "react";
import {
    convertLocalDateToDate,
    formatDateDMYHM,
    formatFullDMY,
} from "crqlar-react-common/dist/utils/date.util";

export function DateElement({date, dateOnly = false}: {
    date: string | Date | undefined;
    dateOnly?: boolean;
}) {
    if (!date) {
        return null;
    }

    const parsedDate = date instanceof Date
        ? date
        : dateOnly && /^\d{4}-\d{2}-\d{2}$/.test(date)
            ? convertLocalDateToDate(date)
            : new Date(date);
    if (!parsedDate || Number.isNaN(parsedDate.getTime())) {
        return null;
    }

    return (
        <span style={{ fontVariantNumeric: "tabular-nums" }}>
            {dateOnly ? formatFullDMY(parsedDate) : formatDateDMYHM(parsedDate)}
        </span>
    );
}
